module.exports = __webpack_public_path__ + "static/img/103353.b646cfc9.png";